import { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import { Button, Col, Input, Modal, Pagination, Select, Space, Spin, Table } from "antd";
import { DeleteFilled, PlusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import ControlBox from "./ControlBox";
import axios from "axios";
import CefrGptSelect from "./CefrGptSelect";
import TranslateInput from "./TranslateInput";
import WrongWordInput from "./WrongWordInput";
import FileCreater from "./FileCreater";
import SettingModal from "./SettingModal";

const backend = process.env.REACT_APP_BACKEND;
const StyledTable = styled((props) => <Table {...props} />)`
  && .selectedRow > td {
    background: paleturquoise;
  }
  && .selectedRow:hover > td {
    background: paleturquoise;
  }
  && tbody > tr:hover > td {
    background: azure;
  }
  .ant-table {
    display: flex;
    flex-direction: column;
  }
  .ant-table > .ant-table-container {
    /*flex-grow: 1;*/
    max-height: 92%;
  }

  
  .custom-footer {
    background-color: #fff; /* 적절한 배경색 지정 */
    padding: 10px; /* 원하는 패딩값 설정 */
    display: flex;
    justify-content: right;
    align-items: center;
  }
  .ant-table-pagination.ant-pagination {
    display: none;
  }
  .ant-table-footer {
    width: 100%;
    padding: 0px;
  }
`


function ConstituentFalseTab ({baseParams, baseParamsHandler, pos, languageGroup}) {

  const [sourceData, setSourceData] = useState([])
  const [loading, setLoading] = useState(false)
  // const [languageGroup, setLanguageGroup] = useState([])
  const [curLanguage, setCurLanguage] = useState({})
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1, // 현재 표시할 페이지
      pageSize: 100, // 한 페이지에 표시할 레코드 수
      showSizeChanger: true, // pageSize변경옵션을 표시할지 여부
      pageSizeOptions: [5, 10, 50, 100, 200],
      showQuickJumper: true, // page 점프
      hideOnSinglePage: false, //pagenation 자체를 사용하고 싶지 않은 경우 pageSize를 최고로 높이면 됨
      showTotal: (total)=>`total ${total} items`,
      total:0
    },
    filters: {
    },
    sorter: {
    }
  });
  const [progressBar, setProgressBar] = useState([0,0])
  const stopRef = useRef(false)
  const [settingModal, setSettingModal] = useState(false)
  const [gptModel, setGptModel] = useState("")

  const tableParamsHandler = (pagination, filter, sorter) => {
    setTableParams({
      ...tableParams,
      pagination:{
        ...tableParams.pagination,
        current: 1
      },
      sorter
    })
  }
  const paginationHandler = (current,pageSize) => {
    setTableParams({
      ...tableParams,
      pagination: {
        ...tableParams.pagination,
        current: pageSize === tableParams.pagination.pageSize ? current : 1,
        pageSize: pageSize,
      }
    })
  }

  const columns = [
    {
      title: "영어단어",
      dataIndex: "word",
      key: "word",
      width: "150px",
      sorter: ()=>(a,b)=>a.word-b.word
    },
    {
      title: "품사",
      dataIndex: "pos_name",
      key: "pos_name",
      width: "130px"
    },
    {
      title: "CEFR레벨(EVP)",
      dataIndex: "cefr_evp",
      key: "cefr_evp",
      width: "140px"
    },
    {
      title: "CEFR레벨(GPT)",
      dataIndex: "cefr_gpt",
      key: "cefr_gpt",
      width: "150px",
      render: (_,record)=><CefrGptSelect record={record} dataChangeHandler={dataChangeHandler} gptModel={gptModel}/>
    },
    {
      title: `해석(${curLanguage.label})`,
      dataIndex: "translate_text",
      key: "translate_text",
      width: "220px",
      render: (_,record)=><TranslateInput record={record} dataChangeHandler={dataChangeHandler} curLanguage={curLanguage} gptModel={gptModel}/>
    },
    {
      title: "영어단어 오답",
      dataIndex: "wrong_word",
      key: "wrong_word",
      width: "220px",
      render: (_,record)=><WrongWordInput record={record} dataChangeHandler={dataChangeHandler} gptModel={gptModel}/>
    },
    {
      title: "음성파일(1.0배속)",
      dataIndex: "translate_voice_filename",
      key: "translate_voice_filename",
      // width: "500px",
      render: (_,record) =><FileCreater record={record} dataChangeHandler={dataChangeHandler} curLanguage={curLanguage}/>
      // <div>
      //   <a style={{margin:"0px 5px"}} onClick={()=>{}}>듣기</a>
      //   <a style={{margin:"0px 5px"}} onClick={()=>{}}>생성</a>
      //   <span>{_}</span>
      //   {_ === null ? null : <a style={{margin:"0px 5px"}} onClick={()=>{}}>듣기</a>}
      // </div>
    }
  ]

  const getSourceData = () => {
    setLoading(true)
    const { current, pageSize } = tableParams.pagination;
    const sorterCol = tableParams.sorter.column?.dataIndex || "id"
    const sorterDirection = tableParams.sorter.order === "ascend" ? "ASC" : "DESC"

    axios
      .get(`${backend}/contents/new_word/constituent_false/list`,
      {params:{
        ...baseParams,
        current: current,
        pageSize: pageSize,
        sorterCol: sorterCol,
        sorterDirection: sorterDirection
      }})
      .then(res=>{
        const newSourceData = res.data.data[0].map((el,idx)=>{
          el.indexNumber = idx
          return el
        })
        setSourceData(newSourceData)
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: res.data.data[1][0]["FOUND_ROWS()"]
          }
        })
        setSelectedKeys([])
        setSelectedRows([])
      })
      .catch(err=>{
        console.log(err)
      })
      .finally(()=>{
        setLoading(false)
      })
  }

  const rowSelection = {
    selectedRowKeys: selectedKeys,
    type: "checkbox",
    onChange: (keys, rows) => {
      setSelectedRows(rows.sort((a, b) => a.indexNumber - b.indexNumber));
      setSelectedKeys(keys.sort((a, b) => a - b));
    },
    getCheckboxProps: (record) => ({
      // disabled: record.hideCheckbox, // 특정 조건일 경우 사용하지 체크하지 못하도록 함
      // className: record.hideCheckbox ? "hidden-checkbox" : "" // 클래스 설정 가능

    })
  }

  // 각 행별 이벤트를 모아놓은 객체를 리턴한다. 필요한 경우에만 사용하도록.
  // const onRowHandler = (record, rowIdx) => {
  //   return {
  //     onClick : () => {
  //       console.log(record)
  //       console.log(rowIdx)
  //     }
  //   }
  // }

  const dataChangeHandler = (record, column) => {
    // state의 변경 전에 임의로 바꾸는 것은 꼼수
    sourceData[record.indexNumber].detail_id = record.detail_id
    sourceData[record.indexNumber][column] = record[column]
    const instance = sourceData.slice()
    instance.splice(record.indexNumber, 1, record)
    setSourceData(instance)
  }

  const stateHandler = (stateName, state) => {
    switch (stateName) {
      case "loading" :
        setLoading(state)
        break
      case "progress" :
        setProgressBar(state)
        break
      case "settingModal" :
        setSettingModal(state)
        break
      case "gptModel" :
        setGptModel(state)
        break

      default : break
    }
  }

  const stopRefHandler = () => stopRef.current = false

  useEffect(()=>{
    getSourceData()
  },[JSON.stringify(baseParams), tableParams.pagination.pageSize, tableParams.pagination.current, tableParams.sorter])

  useEffect(()=>{
    if(languageGroup.length) {
      for(let i=0; i<languageGroup.length; i++) {
        if(baseParams.language === languageGroup[i].value) {
          setCurLanguage(languageGroup[i])
          break
        }
      }
    }
  },[baseParams.language])

  useEffect(()=>{
    axios.get(`${backend}/contents/new_word/constituent_false/gpt`)
    .then(res=>{
      setGptModel(res.data.data[0].gpt_model)
    })
    .catch(err=>{
      console.log(err)
    })
  },[])

  return (
    <div style={{display: "flex", flexDirection:"column", height:"100%"}}>

      <SettingModal settingModal={settingModal} stateHandler={stateHandler} gptModel={gptModel}/>

      <Spin className="mySpin" spinning={loading} tip={
          progressBar[1] ?
          <>
          <div>{`${progressBar[1]} 개 단어 중..${progressBar[0]}개 진행중...`}</div>
          <Button onClick={()=>{stopRef.current=true}}>중지</Button>
          </> : null
      }>
        <div style={{display:"flex", justifyContent:"space-between", marginBottom:"10px"}}>
          <span style={{ minWidth: "100px", textAlign: "left" }}>단어 목록</span>
          <ControlBox
            baseParams={baseParams} 
            baseParamsHandler={baseParamsHandler} 
            pos={pos} 
            languageGroup={languageGroup} 
            stateHandler={stateHandler}
            selectedRows={selectedRows}
            stopRef={stopRef}
            stopRefHandler={stopRefHandler}
            curLanguage={curLanguage}
            dataChangeHandler={dataChangeHandler}
            gptModel={gptModel}
            tableParams = {tableParams}
            paginationHandler={paginationHandler}
          />
        </div>
        
        <div style={{ display: "flex", height:"100%", width:"100%", overflow: "auto" }}>
          <StyledTable
            className="pageTable"
            // onRow={onRowHandler}
            rowSelection={rowSelection}
            columns={columns}
            dataSource={sourceData}
            rowKey="id"
            onChange={tableParamsHandler}
            pagination={tableParams.pagination}
            scroll = {{ x:"max-content", y:"max-content"}}
            footer={()=>
              <div className="custom-footer">
                {
                  tableParams.pagination.total
                  ? <Pagination {...tableParams.pagination} onChange={paginationHandler}/>
                  : null
                }
              </div>}
          ></StyledTable>
        </div>
      </Spin>
    </div>
  )
}

export default ConstituentFalseTab